function getPostDate(date) {
  const p = new Date(date)

  const d = p.getDate()
  const m = p.getMonth() + 1
  const y = p.getFullYear()

  const postDate = `${m}/${d}/${y}`
  return postDate
}

export { getPostDate }
